module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_x-2-chapter-title"
  }, [_c('span', [_vm._v("Prologue"), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-e-1-extract--NO-INDENT-10_para-style-override-20"
  }, [_vm._v("In culture after culture, people believe that the soul lives on after death, that rituals can change the physical world and divine the truth, and that illness and misfortune are caused and alleviated by spirits, ghosts, . . . and gods.")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-e-1-extract--NO-INDENT-10_para-style-override-21"
  }, [_vm._v("—Steven Pinker, How the Mind Works")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT"
  }, [_vm._v("The intriguing apparitions of Cape Cod, Nantucket, and Martha’s Vineyard form an equal-opportunity troupe. Populating these fog-shrouded lands are preachers and pirates, sea captains and sailors, lovers and rogues, witches, glass gaffers, giants, and the innocents whose birthdays numbered far too few. In my previous two books, The Haunting of Louisiana and The Haunting of Mississippi, I chronicled the deeply rooted and often quirky mysteries of Southern folklore. Here on Cape Cod, this peninsula-turned-island, and the neighboring islands of Nantucket and Martha’s Vineyard, Yankee ghosts are staunch and stubborn. They are here whether you believe or not: they ride the waves, gallop on horseback, stroll along the beach, play hide-and-seek, race up hills, dance naked in a cupola, sweep the decks, pilfer make-up, stop a clock, move chairs, rock beds, block doors, and rattle windows. They are the history of the Cape and its islands, woven into myth and legend but steadfastly steering their ghostly vessels through the treacherous shoals of the present.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-22"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-18"
  }, [_vm._v("Each of the chapters ends with ")]), _vm._v("lagniappe "), _c('span', {
    staticClass: "C_span_char-style-override-18"
  }, [_vm._v("(lan yap), a Creole term for a little something extra. When a customer would ")]), _vm._v("make a purchase, the merchant often would include a small gift. The tradition dates")]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2"
  }, [_c('span', [_c('img', {
    staticClass: "frame-1",
    staticStyle: {
      "height": "80%",
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "hcc166.jpg",
      "id": "hcc166_fmt",
      "src": "hcc166_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_caption-14__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticClass: "C_span_italic"
  }, [_vm._v("An anonymous sea captain’s wife at the Colonial House Inn in Yarmouth Port.")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_caption-14__And__Centre_Alignment"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT"
  }, [_vm._v("back to the seventeenth century in France. When weighing the grain, shop keepers would add a few extra kernels. C’est pour la nappe (It’s for the cloth), they would say, as some of the grains tended to stick to the fibers of the material. In New Orleans, where I lived for more than three decades, lagniappe is an accepted daily practice. It is a form of good will, like the thirteenth rose in a bouquet of a dozen long-stemmed roses. The lagniappe at the end of each chapter offers additional background on the ghost or haunted site—perhaps just enough more to entice you to visit these Cape Cod and island locales and seek your own conclusions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "3.50em",
      "color": "#FFFFFF"
    }
  }, [_vm._v("The Haunting")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "3.58em",
      "color": "#FFFFFF"
    }
  }, [_vm._v("of Cape Cod")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "2.67em",
      "color": "#FFFFFF"
    }
  }, [_vm._v("and the Islands")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0